import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["status", {
      review: $props.statusCode === $setup.ReviewStatusCode.REVIEW,
      accept: $props.statusCode === $setup.ReviewStatusCode.ACCEPT,
      reject: $props.statusCode === $setup.ReviewStatusCode.REJECT,
      complete: $props.statusCode === $setup.ReviewStatusCode.COMPLETE,
    }])
  }, [
    _createElementVNode("span", null, _toDisplayString($props.statusName ?? ""), 1 /* TEXT */)
  ], 2 /* CLASS */))
}